module.exports = __webpack_public_path__ + "img/search.bb1a25f2.svg";